const template = require("./quote-terms-template.json");
const unavailable = () => Object.assign(new Error("Conditions historiques indisponibles : utilisez les fichiers existants. Aucune CGV actuelle ne peut leur être substituée."),
  { status: 409, code: "QUOTE_DOCUMENT_TERMS_UNAVAILABLE" });
const projectTermsSnapshot = (snapshot) => {
  if (!snapshot || snapshot.schemaVersion !== 1 || typeof snapshot.templateId !== "string" || !snapshot.templateId.trim()
    || typeof snapshot.validityDateLabel !== "string" || !snapshot.validityDateLabel
    || !Array.isArray(snapshot.blocks) || !snapshot.blocks.length || snapshot.blockCount !== snapshot.blocks.length
    || snapshot.clauseCount !== snapshot.blocks.filter((block) => block?.kind === "heading").length
    || typeof snapshot.commercialTerms?.paymentTerms !== "string" || typeof snapshot.commercialTerms?.riskPreventionText !== "string"
    || snapshot.blocks.some((block) => !["title", "heading", "paragraph", "item"].includes(block?.kind)
      || typeof block.text !== "string" || !block.text.trim() || block.text.includes("{{VALIDITY_DATE}}"))) return null;
  return { schemaVersion: 1, templateId: snapshot.templateId, validityDateLabel: snapshot.validityDateLabel,
    blockCount: snapshot.blockCount, clauseCount: snapshot.clauseCount,
    commercialTerms: { paymentTerms: snapshot.commercialTerms.paymentTerms, riskPreventionText: snapshot.commercialTerms.riskPreventionText,
      ...(typeof snapshot.commercialTerms.paymentScheduleNotice === "string" ? { paymentScheduleNotice: snapshot.commercialTerms.paymentScheduleNotice } : {}) },
    blocks: snapshot.blocks.map(({ kind, text }) => ({ kind, text })) };
};
const createTermsSnapshot = (version, validityDateLabel) => {
  if (!validityDateLabel) {
    const raw = version.validUntil instanceof Date ? version.validUntil.toISOString().slice(0, 10) : version.validUntil;
    const match = typeof raw === "string" && /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
    const date = match && new Date(`${raw}T12:00:00Z`);
    if (!match || Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== raw) {
      throw Object.assign(new Error("La date de validité calculée à la validation est absente ou invalide."),
        { status: 409, code: "QUOTE_DOCUMENT_TERMS_DATE_REQUIRED" });
    }
    validityDateLabel = `${match[3]}/${match[2]}/${match[1]}`;
  }
  return { schemaVersion: 1, templateId: template.templateId, validityDateLabel,
    blockCount: template.blocks.length, clauseCount: template.blocks.filter((block) => block.kind === "heading").length,
    commercialTerms: { paymentTerms: typeof version.paymentTerms === "string" && version.paymentTerms.trim() ? version.paymentTerms.trim() : template.defaultPaymentTerms,
      riskPreventionText: template.riskPreventionText,
      ...((version.paymentSchedule || []).some((item) => item.amountType === "FIXED_AMOUNT") ? { paymentScheduleNotice: "Échéancier fixe ou mixte indicatif : il ne garantit pas la couverture du total du devis. Les montants fixes sont exprimés HT." } : {}) },
    blocks: template.blocks.map(({ kind, text }) => ({ kind, text: text.replace("{{VALIDITY_DATE}}", validityDateLabel) })) };
};
const documentTerms = (version, validityDateLabel) => {
  const recorded = projectTermsSnapshot(version.clientDocument ?? version.calculationSnapshotJson?.clientDocument);
  if (recorded) return recorded;
  if (version.status && !["draft", "validated"].includes(version.status)) throw unavailable();
  if (version.status === "draft") {
    const days = version.validityDays ?? 30;
    if (!Number.isSafeInteger(Number(days)) || Number(days) < 0 || String(days).trim() === "") {
      throw Object.assign(new Error("Renseignez une durée de validité entière positive ou nulle."), { status: 400, code: "QUOTE_VALIDITY_DAYS_INVALID" });
    }
    const label = "Date calculée à la validation";
    const terms = createTermsSnapshot(version, label);
    terms.validityDateLabel = `${Number(days)} jours à compter de la validation (brouillon)`;
    terms.blocks = terms.blocks.map(block => ({ ...block,
      text: block.text.replace(`jusqu’au ${label}`, `pendant ${Number(days)} jours à compter de sa validation`) }));
    return terms;
  }
  return createTermsSnapshot(version, validityDateLabel);
};
module.exports = { createTermsSnapshot, projectTermsSnapshot, documentTerms };
